const initProductSliders = () => {
  const mainImageContainer = document.querySelector('[data-component="productImageCarousel"]');

  // The product-main section's inline script owns this carousel and creates
  // its Swiper instance. Only initialize here as a fallback if nothing has
  // initialized it yet — and never on desktop, where the element is
  // display:none and must not be measured or observed.
  // (Also guards against double-init from the DOMContentLoaded + load listeners below.)
  if (
    mainImageContainer &&
    !mainImageContainer.swiper &&
    typeof Swiper !== 'undefined' &&
    window.matchMedia('(max-width: 767px)').matches
  ) {
    new Swiper(mainImageContainer, {
      slidesPerView: 1,
      spaceBetween: 0,
      scrollbar: {
        el: mainImageContainer.querySelector('[data-slider-scrollbar]'),
        draggable: true,
      },
      navigation: {
        nextEl: mainImageContainer.querySelector('[data-mobile-slider-next]'),
        prevEl: mainImageContainer.querySelector('[data-mobile-slider-prev]'),
      },
      on: {
        // This handles your button opacity logic natively
        init: function() {
          updateBtnState(this);
        },
        slideChange: function() {
          updateBtnState(this);
        }
      }
    });
  }
};

function updateBtnState(swiper) {
  const prev = swiper.navigation.prevEl;
  const next = swiper.navigation.nextEl;
  if (!prev || !next) return;

  prev.classList.toggle('opacity-30', swiper.isBeginning);
  prev.classList.toggle('cursor-not-allowed', swiper.isBeginning);
  next.classList.toggle('opacity-30', swiper.isEnd);
  next.classList.toggle('cursor-not-allowed', swiper.isEnd);
}

// Run immediately and also on a slight delay to catch Shopify's dynamic sections
document.addEventListener('DOMContentLoaded', initProductSliders);
window.addEventListener('load', initProductSliders);